import { motion } from "framer-motion";
import { twMerge } from 'tailwind-merge'

import Loader from "./Loader";
import WalletSlot from "./WalletSlot";
import { Link } from "react-router-dom";

type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  type?: 'primary' | 'secondary' | 'tertiary';
  size?: 'md' | 'sm';
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  loading?: boolean;
  requiresWalletConnection?: boolean;
  to?: string;
  background?: string;
  color?: string;
}

export const Button = (props: ButtonProps) => {
  if (props.requiresWalletConnection) {
    return (
      <WalletSlot>
      {({ connected, connect }) => (
        connected ?
          <_Button {...props} />
          :
          <_Button {...props} onClick={connect} />
        )}
      </WalletSlot>
    )
  }

  return <_Button {...props} />
}

const _Button = (props: ButtonProps) => {
  const { children, className, size = 'md', type = 'primary', onClick: _onClick, disabled, loading, to, background: _background, color: _color } = props;

  const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled || loading) return;
    _onClick?.(e);
  }

  let backgroundColor;
  let boxShadow;
  switch (type) {
    case 'primary':
      backgroundColor = '#60e25e';
      boxShadow = '0px 3px 0px 0 #4db54b';
      break;
    case 'secondary':
      backgroundColor = '#ff4949';
      boxShadow = '0px 3px 0px 0 #b33333';
      break;
    case 'tertiary':
      backgroundColor = '#212425';
      boxShadow = '0px 3px 0px 0 #1a1d1e';
      break;
  }

  let color = '#19191b';
  if (type === 'tertiary') {
    color = '#fff';
  }

  //
  if (_background) {
    backgroundColor = _background;
  }
  if (_color) {
    color = _color;
  }

  if (disabled) {
    backgroundColor = '#848484';
    boxShadow = '0px 3px 0px 0 #3e3e42';
    color = '#3e3e42';
  }

  const Comp = to ? motion(Link) : motion.button;

  return (
    <Comp
      to={to}
      target={to?.startsWith('http') ? '_blank' : undefined}
      whileTap={disabled ? {} : { boxShadow: '0px 0px 0px 0 #000', transform: 'translate(-1px, 2px)' }}
      transition={{ duration: 0.1 }}
      onClick={onClick}
      disabled={disabled}
      className={twMerge(`flex justify-center items-center ${size === 'sm' ? 'h-[34px]' : 'h-11'} relative rounded-lg outline-none mt-[-3px]`, className)}
      style={{
        backgroundColor,
        boxShadow,
      }}
    >
      <div
        className={`flex justify-center items-center flex-grow gap-2 px-6`}
        style={{
          opacity: disabled ? 0.7 : 1
        }}
      >
        {loading && <Loader stroke={color} size="16px" />}
        <div className={`text-${size === 'sm' ? 'sm' : 'base'} font-bold`} style={{ color }}>
          {children}
        </div>
      </div>
    </Comp>
  )
}